import { combineReducers } from "redux";
import { userReducer } from "./user/userSlice";
import { sharedReducer } from "./shared/sharedSlice";
import { notificationReducer } from "./notification/notificationSlice";
import { manageUserReducer } from "./manageUser/manageUserSlice";
import propertyReducer from "./property/propertySlice";
import logHourReducer from "./logHour/logHourSlice";
import mileageReducer from "./mileage/mileageSlice";
import dashboardReducer from "./dashboard/dashboardSlice";
import chatbotReducer from "./chatbot/chatbotSlice";
import activityReducer from "./activity/activitySlice";
import nonRealLogHourReducer from "./nonRealLogHour/nonRealLogHourSlice";
import pricingReducer from "./pricing/pricingSlice";
import auditTrailReducer from "./auditTrail/auditTrailSlice";
import reportReducer from "./report/reportSlice";
import helpCenterReducer from "./helpCenter/helpCenterSlice";
import contactSupportReducer from "./contactSupport/contactSupportSlice";

const rootReducer = combineReducers({
  user: userReducer.reducer,
  manageUser: manageUserReducer.reducer,
  property: propertyReducer.reducer,
  logHour: logHourReducer.reducer,
  mileage: mileageReducer.reducer,
  dashboard: dashboardReducer.reducer,
  chatbot: chatbotReducer.reducer,
  activity: activityReducer.reducer,
  nonRealLogHour: nonRealLogHourReducer.reducer,
  pricing: pricingReducer.reducer,
  auditTrail: auditTrailReducer.reducer,
  report: reportReducer.reducer,
  helpCenter: helpCenterReducer.reducer,
  notification: notificationReducer.reducer,
  contactSupport: contactSupportReducer.reducer,

  shared: sharedReducer.reducer,
});

export default rootReducer;
